const NO_REVIEW_TITLE_DEFAULT = 'Product Review';
const NO_REVIEW_TEXT_DEFAULT = '';

export default {
  properties: {
    Results: {
      type: 'array',
      minItems: 1,
      items: {
        type: 'object',
        properties: {
          ReviewText: {
            type: ['string', 'null'],
            default: NO_REVIEW_TEXT_DEFAULT,
          },
          Rating: {
            type: 'number',
          },
          Title: {
            type: ['string', 'null'],
            default: NO_REVIEW_TITLE_DEFAULT
          },
          SubmissionTime: {
            type: ['string', 'null'],
          },
          UserNickname: {
            type: ['string', 'null'],
          },
          Photos: {
            type: 'array',
            minItems: 1,
            items: {
              type: 'object',
              properties: {
                Id: {
                  type: 'string'
                },
                Sizes: {
                  type: 'object',
                  properties: {
                    thumbnail: {
                      type: 'object',
                      properties: {
                        Url: {
                          type: 'string'
                        }
                      },
                      required: ['Url'],
                    },
                    normal: {
                      type: 'object',
                      properties: {
                        Url: {
                          type: 'string'
                        }
                      },
                      required: ['Url'],
                    }
                  },
                  required: ['thumbnail', 'normal'],
                }
              },
              required: ['Id', 'Sizes'],
            },
          },
        },
        required: [
          'Photos',
          'ReviewText',
          'Rating',
          'Title',
          'SubmissionTime',
          'UserNickname',
        ],
      },
    }
  },
  required: ['Results']
};
